import { env } from "../../config/env";

export const API_DOMAIN = (env.API_ENDPOINT_URL || '').replace(/\/$/, '');

// Centralized URLs and API keys for the Care Guardian job module
export const JOB_MGMT_API_URL = (
  import.meta.env.VITE_JOB_MGMT_API_URL
  || `${API_DOMAIN}/careadmin/job/job-mgmt`
).replace(/\/$/, '');
export const JOBS_API_URL = JOB_MGMT_API_URL;
export const API_GATEWAY_KEY = import.meta.env.VITE_JOB_MGMT_API_KEY || env.API_ENDPOINT_KEY;

// Google services
export const GENAI_API_KEY = env.GEMINI_API_KEY || '';
export const GOOGLE_MAPS_API_KEY = env.GOOGLE_MAPS_API_KEY || '';
export const GOOGLE_MAPS_JS_URL = 'https://maps.googleapis.com/maps/api/js';
export const GOOGLE_MAPS_EMBED_BASE_URL = 'https://www.google.com/maps';

// Admin role gating
export const RoleType = {
	facility: 'facility',
	homecare: 'homecare',
	corporate: 'corporate',
	superadmin: 'superadmin',
	finance: 'finance',
} as const;

export const ADMIN_ROLE_TYPES = [
	RoleType.facility,
	RoleType.homecare,
	RoleType.corporate,
	RoleType.superadmin,
	RoleType.finance,
] as const;

export type AdminRoleType = typeof ADMIN_ROLE_TYPES[number];

export const normalizeRoleType = (roleType?: string | null) => roleType?.toLowerCase().trim() || '';

export const isAdminRole = (roleType?: string | null): roleType is AdminRoleType => {
	const normalized = normalizeRoleType(roleType);
	return ADMIN_ROLE_TYPES.includes(normalized as AdminRoleType);
};
